// chat.reducer.js
import { chatConstants, messageConstants } from '../actions/constants';

const initialState = {
    chats: [],
    loading: false,
    error: null,
    status: 0,
    activeChatId: null,
    lastRaw: null,
};

export default function chatReducer(state = initialState, action) {
    switch (action.type) {
        case chatConstants.FETCH_MY_CHATS_REQUEST:
        case chatConstants.FETCH_CHATS_REQUEST:
        case chatConstants.CREATE_DM_REQUEST:
        case chatConstants.CREATE_ROOM_REQUEST:
        case chatConstants.CREATE_CHAT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                status: 0,
            };

        case chatConstants.FETCH_MY_CHATS_SUCCESS:
        case chatConstants.FETCH_CHATS_SUCCESS: {
            const chats = Array.isArray(action.payload?.chats) ? action.payload.chats : [];

            return {
                ...state,
                loading: false,
                chats,
                error: null,
                status: 200,
                lastRaw: action.payload?.raw || null,
            };
        }

        case chatConstants.CREATE_DM_SUCCESS:
        case chatConstants.CREATE_ROOM_SUCCESS:
        case chatConstants.CREATE_CHAT_SUCCESS: {
            const chat = action.payload?.chat;

            if (!chat?._id) {
                return {
                    ...state,
                    loading: false,
                };
            }

            const exists = state.chats.some((item) => String(item._id) === String(chat._id));
            const chats = exists
                ? state.chats.map((item) => String(item._id) === String(chat._id) ? chat : item)
                : [chat, ...state.chats];

            return {
                ...state,
                loading: false,
                chats,
                activeChatId: chat._id,
                error: null,
            };
        }

        case chatConstants.FETCH_MY_CHATS_FAILURE:
        case chatConstants.FETCH_CHATS_FAILURE:
        case chatConstants.CREATE_DM_FAILURE:
        case chatConstants.CREATE_ROOM_FAILURE:
        case chatConstants.CREATE_CHAT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload?.error || 'Ошибка загрузки чатов',
                status: action.payload?.status || 0,
            };

        case chatConstants.SET_ACTIVE_CHAT_ID:
            return {
                ...state,
                activeChatId: action.payload?.chatId || null,
            };

        case messageConstants.RECEIVE_NEW_MESSAGE: {
            const { message, meId } = action.payload || {};

            if (!message?.chatId) return state;

            const chatId = String(message.chatId);
            const senderId = String(message.sender?._id || message.sender || '');
            const mine = senderId === String(meId || '');

            let found = false;

            const chats = state.chats.map((chat) => {
                if (String(chat._id) !== chatId) return chat;

                found = true;

                const unreadCount = typeof chat.unreadCount === 'number' ? chat.unreadCount : 0;

                return {
                    ...chat,
                    lastMessage: {
                        text: message.text || '',
                        fileName: message.fileName || null,
                        fileUrl: message.fileUrl || null,
                        sender: message.sender,
                        createdAt: message.createdAt,
                        type: 'message',
                    },
                    updatedAt: message.createdAt || chat.updatedAt || new Date().toISOString(),
                    unreadCount: mine ? unreadCount : unreadCount + 1,
                };
            });

            if (!found) return state;

            chats.sort((a, b) => new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0));

            return {
                ...state,
                chats,
            };
        }

        case messageConstants.MARK_MESSAGES_AS_READ_SUCCESS: {
            const { chatId } = action.payload || {};

            if (!chatId) return state;

            const chats = state.chats.map((chat) => (
                String(chat._id) === String(chatId)
                    ? { ...chat, unreadCount: 0 }
                    : chat
            ));

            return {
                ...state,
                chats,
            };
        }

        default:
            return state;
    }
}